import React, {useContext} from 'react';
import {useNavigation} from '@react-navigation/native';

import {SortButton} from './SortButton';

import {RecordsSortContext} from '/context/RecordsSort';

export const SortButtonDataLayer = (props: any, tierName: string) => {
  const navigation = useNavigation();

  /* istanbul ignore next */
  const {sortParams, setSelectedSortParam, setSelectedViewTeam} =
    useContext(RecordsSortContext);

  return (
    <SortButton
      setSelectedViewTeam={setSelectedViewTeam}
      navigate={navigation.navigate}
      sortParams={sortParams}
      tierName={tierName}
      setSelectedSortParam={setSelectedSortParam}
      {...props}
    />
  );
};
